module.exports = __webpack_public_path__ + "static/2015-layer-2-4553a8f1fd16dee8c18414ce4d0ef476.png";